import { observer } from 'mobx-react'
import React, { useContext, useEffect, useState } from 'react'
import './index.scss'
import SelectComponent, { SelectOption } from '@Components/Selectors/Select'
import PaginationComponent from '@Components/Tables/Pagination'
import { transformUserGroupsToSelectOptions } from '@App/helpers/user-groups-to-select-options'
import { StoresContext } from '@App/contexts'
import { PaginationBody, PaginationBodyUsers } from '@Entities/pagination'
import { Maybe } from '@Types'
import UserPermissionsUsersTable from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissions/RightsholderUserPermissionsUsersList/UserPermissionsUsersTable'
import PointPreloader from '@Components/Preloaders/PointPreloader'

const limitItems = 10

const RightsholderUserPermissionsUsersList = () => {
    const { rightsholderUserStore, rightsholderStore, userStore } = useContext(StoresContext)
    const [pagination, setPagination] = useState<PaginationBodyUsers>({
        page: 1,
        limit: limitItems,
    })
    const [selectedGroup, setSelectedGroup] = useState<Maybe<SelectOption>>()
    const [loading, setLoading] = useState<boolean>(false)

    const loadRightsholders = async () => {
        setLoading(true)
        await rightsholderUserStore.loadRightsholderUsers({ ...pagination, group: selectedGroup?.id })
        setLoading(false)
    }

    useEffect(() => {
        loadRightsholders().then()
    }, [])

    useEffect(() => {
        loadRightsholders().then()
    }, [pagination, selectedGroup])

    const currentMemberSummary = rightsholderStore.memberSummary
    const rightsholderUsers = rightsholderUserStore.rightsholderUsers
    const paginationPages = rightsholderUserStore.rightsHolderUsersPagination

    const userGroups = userStore.permissionGroupsFiltered
    const userGroupsOptions = transformUserGroupsToSelectOptions(userGroups)

    if (!rightsholderUsers) {
        return <PointPreloader />
    }

    return (
        <div className="rightsholder-user-permissions-users-tab">
            <div className="search-users-block">
                <p className="bold small info-count">
                    <span className="bold small">
                        {rightsholderUsers.totalElements ? rightsholderUsers.totalElements : 0} Users for{' '}
                    </span>
                    <span title={currentMemberSummary.name} className="bold small">
                        &quot;{currentMemberSummary.name}&quot;
                    </span>
                </p>
                <div className="search">
                    {userGroupsOptions && (
                        <SelectComponent
                            options={userGroupsOptions}
                            onValueChange={(value: SelectOption) => setSelectedGroup(value)}
                            activeInputState
                            placeholder="Select Group"
                            isClearable
                        />
                    )}
                </div>
            </div>
            <div className="head-users-block">
                <p>
                    {selectedGroup ? selectedGroup.label : 'All'}: {rightsholderUsers.totalElements} Users
                </p>
            </div>
            {loading ? <PointPreloader /> : <UserPermissionsUsersTable eventGetUsers={loadRightsholders} />}
            {rightsholderUsers.totalElements > limitItems && (
                <PaginationComponent
                    limit={limitItems}
                    paginationPages={paginationPages}
                    onChange={(newPagination: PaginationBody) => setPagination(newPagination)}
                />
            )}
        </div>
    )
}

export default observer(RightsholderUserPermissionsUsersList)
